
import { React, useState, useEffect } from 'react'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckOutForm from './CheckOutForm';

function StripePayment({ setWalletRechargeModal, walletRechargeModal, amountToAdd = 10, autoPayProp }) {
  console.log("walletRechargeModal in stripeform", walletRechargeModal)

  // const [amount, setAmount] = useState(null)
  const [paymentOptionAmount, setPaymentOptionAmount] = useState(10)
  console.log("paymentOptionAmount in stripeform", paymentOptionAmount)

  // const getAmountToAdd = (amountVal)=>{
  //   setPaymentOptionAmount(amountVal)
  // }




  


  



  // const stripePromise = loadStripe('const stripePromise = loadStripe('pk_test_51MgMVRAPmgE2jEzZNLL7fojhCo052rXCR634fbmKPaVZL3lM1kM4QtRUWU6RvFl2BmQMeDBucOpgQDuDBV0lJ9ov00PmEkcwVC');
  // const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  // Source - https://stackoverflow.com/a/64694798
// Posted by Nikita Chayka, modified by community. See post 'Timeline' for change history
// Retrieved 2026-02-23, License - CC BY-SA 4.0

  const [stripePromise, setStripePromise] = useState(() => loadStripe(process.env.REACT_APP_STRIPE_KEY))

  const options = {
    mode: 'payment',
    // paymentMethodOrder: ['amazon_pay','card'],
    currency: 'usd',
    // wallets: {
    //   applePay:(autoPay || saveCard) ? 'never' : 'always',
    //   googlePay:(autoPay || saveCard) ? 'never' : 'always'
    // },
    amount: Math.round(paymentOptionAmount * 100), // Convert to cents
    setup_future_usage: 'off_session',
    // payment_method_types : (autoPay || saveCard) ? ['card'] : []

  }
  // const [options, setOptions] = useState({
  //   mode: 'payment',
  //   // paymentMethodOrder: ['amazon_pay','card'],
  //   currency: 'usd',
  //   // wallets: {
  //   //   applePay:(autoPay || saveCard) ? 'never' : 'always',
  //   //   googlePay:(autoPay || saveCard) ? 'never' : 'always'
  //   // },
  //   amount: paymentOptionAmount * 100, // Convert to cents
  //   setup_future_usage: 'off_session',
  //   // payment_method_types : (autoPay || saveCard) ? ['card'] : []

  // })

  // const options = useMemo(() => ({
  //   mode: 'payment',
  //   currency: 'usd',
  //   amount: paymentOptionAmount * 100, // Convert to cents
  //   setup_future_usage: 'off_session'
  // }), [paymentOptionAmount]);
  // const [autoPay, setAutoPay] = useState(autoPayProp);
  // const [saveCard, setSaveCard] = useState(false)

  // let options = {
  //   mode: 'payment',
  //   // paymentMethodOrder: ['amazon_pay','card'],
  //   currency: 'usd',
  //   // wallets: {
  //   //   applePay:(autoPay || saveCard) ? 'never' : 'always',
  //   //   googlePay:(autoPay || saveCard) ? 'never' : 'always'
  //   // },
  //   amount: paymentOptionAmount * 100, // Convert to cents
  //   setup_future_usage: 'off_session',
  //   // payment_method_types : (autoPay || saveCard) ? ['card'] : []

  // }

  // useEffect(() => {
  //   console.log("payment option amount change : ", paymentOptionAmount)
  //   setOptions({
  //     mode: 'payment',
  //     // paymentMethodOrder: ['amazon_pay','card'],
  //     currency: 'usd',
  //     // wallets: {
  //     //   applePay:(autoPay || saveCard) ? 'never' : 'always',
  //     //   googlePay:(autoPay || saveCard) ? 'never' : 'always'
  //     // },
  //     amount: paymentOptionAmount * 100, // Convert to cents
  //     setup_future_usage: 'off_session',
  //     // payment_method_types : (autoPay || saveCard) ? ['card'] : []

  // } )

  // console.log("Options", options)
  // }, [paymentOptionAmount])

  
  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckOutForm setWalletRechargeModal={setWalletRechargeModal} setPaymentOptionAmount={setPaymentOptionAmount} walletRechargeModal={walletRechargeModal} amountToAdd={amountToAdd}/>
    </Elements>
  )
}

export default StripePayment;



{/* <StripeProvider apiKey='publishable_API_Key'>  
	<Elements>
		<CardElement hidePostalCode={true} style={{ base: { fontSize: '18px' } }} />
      </Elements>
</StripeProvider>

this.props.stripe.createToken({
      name: formProps.name,
      address_line1: formProps.address,
      address_city: formProps.city,
      address_state: formProps.state,
      address_zip: formProps.zipCode,
      address_country: formProps.country
}).then(({ token }) => {
               if (!token) return;
		//if token generated successfully, then the token will send to BackEnd.
}});

export default injectStripe(CardInfo); */}